import React, { useEffect, useState } from "react";
import AnimatedLogo from "./AnimatedLogo";
import BrandTagline from "./BrandTagline";

/**
 * SplashScreen — écran d'accueil animé au lancement :
 *   - le nom « Gively » et la baseline sont là DÈS LE DÉBUT (on a le temps de lire) ;
 *   - le logo se déploie (camembert bleu -> vert -> violet) et révèle le G ;
 *   - après un temps de lecture confortable, l'overlay s'efface en fondu.
 *
 * Garde-fous : 1x/session ; OVERLAY (l'app se rend dessous -> aucun impact SEO/LCP) ;
 * prefers-reduced-motion respecté ; l'overlay disparaît au plus tard après ~4 s.
 */
const SESSION_KEY = "gv_splash_seen";
const HOLD_MS = 3400; // temps total d'affichage avant le fondu de sortie

export default function SplashScreen() {
  const [show, setShow] = useState(() => {
    try {
      return sessionStorage.getItem(SESSION_KEY) !== "1";
    } catch {
      return true;
    }
  });
  const [leaving, setLeaving] = useState(false);

  useEffect(() => {
    if (!show) return;
    try {
      sessionStorage.setItem(SESSION_KEY, "1");
    } catch {
      /* mode privé strict : on n'empêche pas l'affichage */
    }
    const leave = setTimeout(() => setLeaving(true), HOLD_MS);
    const gone = setTimeout(() => setShow(false), HOLD_MS + 560);
    return () => {
      clearTimeout(leave);
      clearTimeout(gone);
    };
  }, [show]);

  if (!show) return null;

  return (
    <div
      aria-hidden="true"
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 9998,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "24px",
        background: "radial-gradient(120% 120% at 50% 38%, #ffffff 0%, #f5f7fb 70%, #eef1f7 100%)",
        opacity: leaving ? 0 : 1,
        transition: "opacity 0.54s ease",
        pointerEvents: leaving ? "none" : "auto",
      }}
    >
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 18, textAlign: "center" }}>
        <AnimatedLogo size={134} duration={1.4} />

        {/* Nom + baseline présents DÈS LE DÉBUT (Lucas) */}
        <span
          style={{
            fontFamily: "Manrope, Inter, sans-serif",
            fontWeight: 800,
            fontSize: 27,
            letterSpacing: "-0.02em",
            color: "#0f172a",
          }}
        >
          Gively
        </span>
        <BrandTagline size={18} />
      </div>
    </div>
  );
}
